import React__default from 'react';

var Link = function Link(_ref) {
  var content = _ref.content,
      href = _ref.href;
  return /*#__PURE__*/React__default.createElement("a", {
    className: "dropdown-tab",
    target: "_blank",
    href: href
  }, content);
};

export { Link };
